module.exports = __webpack_public_path__ + "static/media/Norfolk-Serif.9ef09105.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Norfolk-Serif.eot
// module id = 2078
// module chunks = 53